import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

const AvatarCard = ({ avatar, name, position }) => {
   return (
      <div className="text-xs flex gap-4 py-4 border-t border-solid border-white/10">
         <div className="flex-none">
            <div className="w-8 h-8 overflow-hidden rounded-full">
               <img
                  className="w-full"
                  src={`/assets/custom/communities/images/features/messages/${avatar}.jpg`}
                  alt="Messages"
               />
            </div>
         </div>
         <div className="text-xs text-white">
            <div className="text-xs">{name}</div>
            <div className="opacity-50">{position}</div>
         </div>
      </div>
   )
}

AvatarCard.propTypes = {
   avatar: PropTypes.string.isRequired,
   name: PropTypes.string.isRequired,
   position: PropTypes.string.isRequired
}

const MessagesFeature = ({ active }) => {
   const [visible, setVisible] = useState(false)

   useEffect(() => {
      if (active) {
         setTimeout(() => {
            setVisible(true)
         }, 200)
      } else {
         setVisible(false)
      }
   }, [active])

   return (
      <div className="w-full h-full">
         <div
            className={classNames(
               'absolute flex items-end h-[500px] bottom-[15%] left-[15%] w-[70%] p-4 bg-white rounded-3xl overflow-hidden shadow-[0px_10px_30px_rgba(0,0,0,0.3)] transition-all duration-700',
               visible ? 'translate-y-0 opacity-80' : '-translate-y-10 opacity-0'
            )}>
            <img
               className="w-full"
               src="/assets/custom/communities/images/features/messages/1.jpg"
               alt="Messages"
            />
         </div>

         <div
            className={classNames(
               'absolute top-[10%] sm:top-[20%] left-[10%] sm:left-[50%] w-[900px] rounded-3xl overflow-hidden shadow-[0px_10px_30px_rgba(0,0,0,0.3)] border border-solid border-neutral-100/10 bg-neutral-900/95 backdrop-blur-sm transition-all duration-700 delay-200 scale-[70%] sm:scale-100',
               visible ? 'translate-y-0 opacity-100' : '-translate-y-10 opacity-0'
            )}>
            <div className="px-6">
               <div className="flex items-center h-12 text-xs text-white font-semibold">Group Members</div>
               <AvatarCard avatar="sam" name="Samantha Reyez" position="Community Manager" />
               <AvatarCard avatar="hailey" name="Hailey Andersson" position="Creative Director, Studio Tomorrow" />
               <AvatarCard avatar="jordan" name="Jordan Richards" position="Head of Product, Aethra" />
            </div>
         </div>
      </div>
   )
}

MessagesFeature.propTypes = {
   active: PropTypes.bool.isRequired
}

export default MessagesFeature
